// src/screens/PreCount/RollsWrittenTip.js
import React, { useContext, useState } from 'react';
import CountContext from '../../context/CountContext.js';

export default function RollsWrittenTip({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const { rolls, writtenTipConfirmed } = state;

  // Local state for roll inputs
  const [inputs, setInputs] = useState({
    quarters: rolls.quarters.toString(),
    dimes: rolls.dimes.toString(),
    nickels: rolls.nickels.toString(),
    pennies: rolls.pennies.toString(),
  });

  // Handle changes, sanitize digits only
  const handleChange = (denom) => (e) => {
    let raw = e.target.value.replace(/[^0-9]/g, '');
    if (raw === '') raw = '0';
    setInputs((prev) => ({ ...prev, [denom]: raw }));
    dispatch({
      type: 'UPDATE_ROLLS', payload: {
        ...rolls,
        [denom]: parseInt(raw, 10),
      }
    });
  };

  // Compute total value of rolls
  const rollsValue =
    parseInt(inputs.quarters, 10) * 10 +
    parseInt(inputs.dimes, 10) * 5 +
    parseInt(inputs.nickels, 10) * 2 +
    parseInt(inputs.pennies, 10) * 0.5;

  // Confirm written tips
  const handleWrittenTip = (e) => {
    dispatch({ type: 'CONFIRM_WRITTEN_TIP', payload: e.target.checked });
  };

  // Confirm and continue
  const handleConfirm = () => {
    onNext();
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-4">
      <h2 className="text-2xl font-bold mb-4">Rolls & Written Tips</h2>

      {[
        { key: 'quarters', label: 'Rolls of Quarters ($10 each)' },
        { key: 'dimes', label: 'Rolls of Dimes ($5 each)' },
        { key: 'nickels', label: 'Rolls of Nickels ($2 each)' },
        { key: 'pennies', label: 'Rolls of Pennies ($0.50 each)' },
      ].map(({ key, label }) => (
        <div key={key} className="flex items-center space-x-4 mb-2">
          <label className="w-60">{label}</label>
          <input
            type="text"
            value={inputs[key]}
            onChange={handleChange(key)}
            onFocus={(e) => e.target.select()}
            className="border rounded p-1 w-20"
          />
        </div>
      ))}

      <div className="mt-2 font-semibold">
        Total Rolls Value: ${rollsValue.toFixed(2)}
      </div>

      <div className="mb-6">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={writtenTipConfirmed}
            onChange={handleWrittenTip}
            className="mr-2"
          />
          <span className="text-xl font-bold">
            Have you verified all written tips are entered in the POS?
          </span>
        </label>
      </div>


      <div className="flex justify-between mt-6">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Back
        </button>
        <button
          onClick={handleConfirm}
          className="px-4 py-2 bg-blue-500 text-white rounded"
          disabled={!writtenTipConfirmed}
        >
          Confirm & Continue
        </button>
      </div>
    </div>
  );
}
